import moji from 'moji';

export const hanToZen = (str) =>
  moji(str).convert('HE', 'ZE').convert('HS', 'ZS').toString();

export const zenToHan = (str) =>
  moji(str).convert('ZE', 'HE').convert('ZS', 'HS').toString();

export const ganaToKana = (str) =>
  moji(str).convert('HG', 'KK').toString();

export const kanaToGana = (str) =>
  moji(str).convert('KK', 'HG').toString();

export const spaceZenToHan = (str) =>
  moji(str).convert('ZS', 'HS').toString();

export const isValidJSON = obj => {
  try {
    JSON.parse(obj);
    return true;
  } catch (e) {
    return false;
  }
};

export const getURLParameters = url =>
  (url.match(/([^?=&]+)(=([^&]*))/g) || []).reduce(
    (a, v) => ((a[v.slice(0, v.indexOf('='))] = v.slice(v.indexOf('=') + 1)), a),
    {}
  );

export const mapByProp = (prop, data) => {
  return data.reduce((val, obj) => (val[obj[prop]] = obj, val), {});
};

export const setIdBy = (datas, idKeys) => {
  return datas.map(data => {
    let id = '';
    idKeys.forEach((key, i) => {
      if (i === idKeys.length - 1) {
        id += data[key];
      } else {
        id += data[key] + '_';
      }
    })
    data.id = id;
    return data;
  });
}

export const formatPhone = (_phone) => {
  if (_phone == null) {
    return _phone;
  }

  const phone = zenToHan(_phone).trim();
  if (phone.indexOf("-") !== -1) {
    return phone;
  }

  if (phone.length == 11) {
    return `${phone.substring(0, 3)}-${phone.substring(3, 7)}-${phone.substring(7, 11)}`;
  }

  if (phone.length == 10 && (phone.indexOf('03') === 0 || phone.indexOf('06') === 0)) {
    return `${phone.substring(0, 2)}-${phone.substring(2, 6)}-${phone.substring(6, 10)}`;
  }

  if (phone.length == 10) {
    return `${phone.substring(0, 3)}-${phone.substring(3, 6)}-${phone.substring(6, 10)}`;
  }

  return phone;
};

export const formatPrice = (price) => {
  let sb = '';
  if (price < 0) {
    sb += '-';
    price = -1 * price;
  }
  const price10_8 = Math.floor(price / 100000000);
  price %= 100000000;
  const price10_4 = Math.floor(price / 10000);
  price %= 10000;
  if (price10_8 != 0) {
    sb += price10_8;
    sb += '億';
  }
  if (price10_4 != 0) {
    sb += price10_4;
    sb += '万';
  }
  sb += Math.floor(price);
  sb += '円';
  return sb;
}

export const checkBit = (byte, index) => {
  return byte.toString('2')[index] === '1';
};

export const getDiff = (org, data) => {
  const diff = {};
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const val = data[key];
      const orgVal = org[key];
      if (Array.isArray(val)) {
        if (val.join('\r') !== orgVal.join('\r')) {
          diff[key] = val;
        }
        continue;
      }

      if (val !== orgVal) {
        diff[key] = val;
      }
    }
  }
  return diff;
};

export const copy2ClipBoard = (string) => {
  const temp = document.createElement('textarea');
  temp.value = string;
  temp.selectionStart = 0;
  temp.selectionEnd = temp.value.length;
  const s = temp.style;
  s.position = 'fixed';
  s.left = '-100%';
  document.body.appendChild(temp);
  temp.focus();
  const result = document.execCommand('copy');
  temp.blur();
  document.body.removeChild(temp);
  return result;
}